import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDistributor, IDistributorRes, IDistributorResA } from 'app/interfaces/distributor';
import { IUser, IUserResA } from 'app/interfaces/user.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DistributorService {
  API_URL = environment.apiUrl;
  route = '/distributors';

  constructor(
    private http: HttpClient
  ) { }

  get(): Observable<IDistributorResA> {
    return this.http.get<IDistributorResA>(`${this.API_URL}${this.route}`, {});
  }

  show(id: number): Observable<IDistributorRes> {
    return this.http.get<IDistributorRes>(`${this.API_URL}${this.route}/${id}`, {});
  }
  
  checkDistributor(): Observable<IDistributorRes> {
    return this.http.get<IDistributorRes>(`${this.API_URL}${this.route}-search`, {});
  }

  store(data: IDistributor): Observable<IDistributorRes> {
    return this.http.post<IDistributorRes>(`${this.API_URL}${this.route}`, {
    ...data
    });
  }

  showUsers(id: any): Observable<IDistributorRes> {
    return this.http.get<IDistributorRes>(`${this.API_URL}/users-provider/${id}`, {});
  }

  saveBooks(data: any): Observable<IDistributorRes> {
    return this.http.post<IDistributorRes>(`${this.API_URL}${this.route}/update/books`, {
    ...data
    });
  }

  saveUsers(data: any): Observable<IDistributorRes> {
    return this.http.post<IDistributorRes>(`${this.API_URL}/users-provider`, {
    ...data
    });
  }

  delete(id: number): Observable<IDistributorRes> {
    return this.http.delete<IDistributorRes>(`${this.API_URL}${this.route}/${id}`, {});
  }

  update(data: IDistributor): Observable<IDistributorRes> {
    return this.http.put<IDistributorRes>(`${this.API_URL}${this.route}/${data.id}`, {
    ...data
    });
  }
}

